// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';
import SwatchManager from 'snippets/card/card';
import 'snippets/product-carousel/product-carousel';

// Style includes
import './_product-recommendations.scss';

// -------------------------------------
// Variables
// -------------------------------------
const RECOMMENDATIONS_SELECTOR = '.product-recommendations';
const ADD_TO_CART_FORM = 'form[action="/cart/add"]';

const swatchManagerConfig = {
    CARD_PRODUCT: '.card--product',
    CARD_IMAGE_WRAPPER: '.card__image-wrapper',
    CARD_PRODUCT_IMAGE: '.card__product-image',
    CARD_COLOR_OPTION: '.card__swatch--color-option',
    CARD_COLOR_SWATCHES: '.card__color-swatches',
    SELECTED_CLASS_NAME: 'selected',
    ADD_TO_CART_FORM,
    INPUT_VARIANT_ID: 'input[name="id"]',

    CARD_TEXT_OPTION: '.card--text-swatch',
    CARD_TEXT_SWATCHES: '.card__text-swatches',
};

// -------------------------------------
// Helpers
// -------------------------------------

const swatchManager = new SwatchManager(swatchManagerConfig);

const initProductRecommendations = () => {
    const productRecommendations = document.querySelectorAll(RECOMMENDATIONS_SELECTOR);

    productRecommendations.forEach((productRecommendation) => {
        const observer = new IntersectionObserver((entries, observer) => {
            handleIntersection(entries, observer);
        }, { rootMargin: '0px 0px 200px 0px' });

        observer.observe(productRecommendation);
    });
};

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    const $elem = entries[0].target;
    const url = $elem.dataset.url;

    if(!url) return;

    observer.unobserve($elem);

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(RECOMMENDATIONS_SELECTOR);
            if (recommendations && recommendations.innerHTML.trim().length) {
                $elem.innerHTML = recommendations.innerHTML;
            }

            document.querySelectorAll(swatchManagerConfig.CARD_COLOR_OPTION).forEach((element) => {
                element.addEventListener('click', (element) => {
                    element.stopPropagation();
                    const selectedSwatchOption = element.currentTarget;
                    swatchManager.changeSwatch(selectedSwatchOption, 'color');
                });
                element.addEventListener('keydown', (element) => {
                    element.stopPropagation();
                    if (element.key === 'Enter') {
                        const selectedSwatchOption = element.currentTarget;
                        swatchManager.changeSwatch(selectedSwatchOption, 'color');
                    }
                });
            });

            document.querySelectorAll(swatchManagerConfig.CARD_TEXT_OPTION).forEach((element) => {
                element.addEventListener('click', (element) => {
                    element.stopPropagation();
                    const selectedSwatchOption = element.currentTarget;
                    swatchManager.changeSwatch(selectedSwatchOption, 'text');
                });
                element.addEventListener('keydown', (element) => {
                    element.stopPropagation();
                    if (element.key === 'Enter') {
                        const selectedSwatchOption = element.currentTarget;
                        swatchManager.changeSwatch(selectedSwatchOption, 'text');
                    }
                });
            });
        }).then(() => {
            Shopify.AjaxifyCart().init({ addToCartFormSelector: `${RECOMMENDATIONS_SELECTOR} ${ADD_TO_CART_FORM}` });
        })
        .catch(e => {
            console.error(e);
        });
};

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    initProductRecommendations();
});

